module.exports = __webpack_public_path__ + "img/07-เปลี่ยนแปลงแก้ไขอีเมล์.ed21cfbd.png";